export default "/FRAX.bfb0b734e5c50876043557fb400687e7.svg";